export default "__VITE_ASSET__B5hABBPe__"